import React, { useState } from 'react';
import styled from 'styled-components';

import { MdKeyboardArrowDown } from 'react-icons/md'

const Wrapper = styled.div`
    border: 1px solid var(--darkgreen);
    min-width: 100px;
    width: 3vw;
    padding: 0.75vh 1vh 0.75vh 1vh;

    position: relative;

    background-color: whitesmoke;

    .selected{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: IBM Plex Mono Bold;
    }
    
    cursor: pointer;

    .dropdown{
        z-index: 2;
        position: absolute;
        top: 100%;
        left: -1px;

        display: ${props => props.open ? "auto" : "none"};
        background-color: whitesmoke;
        border: 1px solid grey;

        width: calc(100% + 2px);

        div{
            padding: 10px 10px;
            
            &:hover{
                background-color: rgba(0, 0, 0, 0.1);
            }
        }
    }

    @media(max-width: 1000px)
    {
        padding: 1.25vh 1.75vh 1.25vh 2.5vh;
    }
`;

export default function Dropdown({ amount, setAmountIndex, variants })
{
    const [open, setOpen] = useState(false);

    const handleChangeAmount = (e) => {
        setAmountIndex(parseInt(e.target.getAttribute('name')))
        setOpen(false);
    }

    const onOpenDropdown = (e) => {
        e.preventDefault();
        setOpen(!open);
        // if(variants.length > 1)
        // {
        //     setOpen(!open);
        // }
    }

    return(
        <Wrapper open={open} numVariants={variants?.length}>
            <div onClick={onOpenDropdown} className="selected">
                {amount}
                <MdKeyboardArrowDown style={{ fontSize: '2.25vh', paddingTop: 3 }}/>
            </div>
            
            <div className="dropdown">
                {variants?.map((variant, index) => {
                    return(
                        <div 
                            key={variant.option}
                            name={index}
                            onClick={handleChangeAmount}
                        >
                            {variant.option}
                        </div>
                    )
                })}
            </div>
        </Wrapper>
    )
}